'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChangeUserController = function () {
    /* @ngInject */
    function ChangeUserController($scope, $state, localStorageService, $translate, ApiUser, $ionicPopup, $ionicLoading, ApiPicklist, MessageBox, $rootScope) {
        _classCallCheck(this, ChangeUserController);

        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$state = $state;
        this.ApiUser = ApiUser;
        this.localStorageService = localStorageService;
        this.ApiPicklist = ApiPicklist;
        this.MessageBox = MessageBox;
        this.user = {};
        this.loading = [];
        this.$rootScope = $rootScope;
        this.isPurchase = false;
    }

    _createClass(ChangeUserController, [{
        key: 'init',
        value: function init() {
            this.getUser();
            this.getCountries();
            this.getEuropeanCountryList();
        }
    }, {
        key: 'showLoading',
        value: function showLoading() {
            this.loading.push(1);
            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });
        }
    }, {
        key: 'hideLoading',
        value: function hideLoading() {
            this.loading.pop();
            if (this.loading.length <= 0) {
                this.$ionicLoading.hide();
            }
        }
    }, {
        key: 'getUser',
        value: function getUser() {
            var _this = this;

            this.showLoading();
            this.ApiUser.getUser().then(function (res) {
                if (typeof res != 'undefined') {
                    _this.user = res;
                    _this.hideLoading();
                } else {
                    _this.hideLoading();
                }
            });
        }
    }, {
        key: 'getCountries',
        value: function getCountries() {
            var _this2 = this;

            this.showLoading();
            this.ApiPicklist.getAdvindaCountries().then(function (countries) {
                _this2.contactCountries = countries.data.sort();
                _this2.hideLoading();
            });
        }
    }, {
        key: 'changeUser',
        value: function changeUser() {
            var _this3 = this;

            this.showLoading();
            this.ApiUser.changeUser(this.user, this.isPurchase).then(function (res) {
                _this3.hideLoading();
                _this3.$rootScope.user = res;
                if (res) {
                    _this3.$state.go('user');
                }
            });
        }
    }, {
        key: 'getEuropeanCountryList',
        value: function getEuropeanCountryList() {
            var _this4 = this;

            this.showLoading();
            this.ApiPicklist.getEuropeanUnionCountries().then(function (countries) {
                _this4.europeanCountries = countries.data.sort();
                _this4.hideLoading();
            });
        }
    }]);

    return ChangeUserController;
}();

exports.default = ChangeUserController;


/** WEBPACK FOOTER **
 ** ./src/app/components/user/changeUser.controller.js
 **/